<template>
  <div class="account-balance__cash-chip">
    <div class="account-balance__cash-chip-wrapper">
      <div class="account-balance__cash-chip-left">
        <slot name="left">
          <template v-if="money">
            {{ value > 0 ? '+' : '-' }}
          </template>
        </slot>
      </div>

      <div class="account-balance__cash-chip-cnt">
        {{ text }}
      </div>

      <div class="account-balance__cash-chip-right">
        <slot name="right">
          <span
            v-if="money"
            class="lighter"
          >
            JBN
          </span>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AccountBalanceChip',

    props: {
      value: {
        required: true
      },
      money: {
        type: Boolean
      }
    },

    computed: {
      text() {
        let result = this.value.toString();

        if (this.money) {
          result = result
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1 `)
            .replace('-', '');
        }

        return result;
      },
    }
  };
</script>
